<!--
  - Copyright (c) ProviderTrust LLC.
  - All Rights Reserved.
  -
  - This software is confidential and proprietary information of
  - ProviderTrust LLC ("Confidential Information"). You shall not disclose
  - such Confidential Information and shall use it only in
  - accordance with the terms of the license agreement you entered
  - into with ProviderTrust.
-->

<template>
  <registration-template>
    <h1 slot="header-title">Thank you!</h1>

    <div slot="content">
      <p v-if="planType === 'COMPANY'">
        Thank you for signing up for ExclusionCheck! We're sending you an email
        with account and billing details right now. Go ahead and get started
        below.
      </p>
      <p v-else-if="planType === 'INVITATION'">
        Thank you for signing up for ExclusionCheck! Go ahead and get started
        below.
      </p>
      <p v-else>
        Thanks for signing up for a Trial Account. You'll be able to perform up
        to 10 searches each month. When you're ready to upgrade just let us
        know!
      </p>

      <v-btn
        color="primary"
        class="font-bold app-start-searching-btn mt-5"
        @click.native="redirect('/')"
      >
        Start Searching
      </v-btn>
    </div>
  </registration-template>
</template>
<script>
import RegistrationTemplate from "./Registration-Template"
import { mapGetters, mapMutations } from "vuex"
import redirect from "@/service/redirect"

export default {
  name: "RegistrationThankYou",

  components: {
    RegistrationTemplate
  },

  computed: mapGetters(["planType"]),

  methods: {
    ...mapMutations(["updateCurrentStep"]),
    redirect
  }
}
</script>
<style lang="scss" scoped>
.app-start-searching-btn {
  font-size: 1.7rem;
  min-width: 27.6rem;
  height: 4rem;
  text-transform: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Registration-Thank-You.vue